import React, {Component} from 'react';
// Custom module import 
import { 
		validEmailRegex , 
		objectValuesEmpty, 
		flash 
	} from './../helpers.js'

class CPAddTown extends Component{

	constructor(props){
		super(props);
		this.state = {
			stateid:'',
			lgaid:'',
			name:'',
			status:false,
			errors: {
		        stateid: '',
		        lgaid: '',
		        name: '',
		    },
		    isSubmitting: false,
		}
	}

	// Handle registration form
	CPSaveTown = event => {
		event.preventDefault();
		// Verify for errors again
		// And Display errors under the empty fields
    	let errors = this.state.errors;
    	let state = Object.assign({}, this.state);
    	Object.entries(state).map((field) => {
    		let toValidate = ['stateid', 'lgaid', 'name', 'status'];
    		if(toValidate.includes(field[0])){
    			errors.[field[0]] = state.[field[0]] == '' || state.[field[0]] == undefined || state.[field[0]] == null
	            ? `${ field[0].charAt(0).toUpperCase()+field[0].slice(1) } is Required`
	            : '';
    		}
    	});

		if( objectValuesEmpty(this.state.errors) ) {
			// disable submit button
			this.setState({ isSubmitting : true })

			// Send form data
			this.props.addTown({
				stateid: this.state.stateid, 
				lgaid: this.state.lgaid, 
				name: this.state.name, 
				status: this.state.status
			});
	    }else{
	    	// reactivate button
	    	this.setState({isSubmitting: false});

	    	// Show message
	    	const theme = 'panel bordered primary rounded';
	    	const icon =`fa fa-times-circle`;
	    	const message ='Kindly fix the following errors';
  			flash(theme, icon, message, '#alert');
	    }
	}

	// Handle input field change
	handleFieldChange = (event) => {
		event.preventDefault();

		// Get input name and value
		const { name, value } = event.target;
		
		// Fill form field
		this.setState( { [name] : value } );

		// Check for errors
		// TODO: do more validation
		let errors = this.state.errors;
		switch(name){
			case 'stateid':
				errors.stateid = 
	          	value == '' || value == undefined
	            ? 'State Name Required'
	            : '';
	        break;

			case 'lgaid':
				errors.lgaid = 
	          	value == '' || value == undefined
	            ? 'LG Name Required'
	            : '';
	        break;

			case 'name':
				errors.name = 
	          	value == '' || value == undefined
	            ? 'Name Required'
	            : '';
	        break;
		}
		this.setState({errors, [name]: value});
	}

	render(){
		let errors = this.state.errors;

		return (
			<React.Fragment>
				<div id="alert" className="hide">
					<span className="icon"><i className="" id="icon"></i></span>
					<span className="message" id="message"></span>
				</div>
				<form id="townForm" className="grouped row spread bottom" onSubmit={ this.CPSaveTown}>
					<div>
						<div className="row">
						    <div className="helper">
						    	<label htmlFor="stateid">State Name</label>
						    	<input value={ this.state.stateid } onChange={ this.handleFieldChange } type="text" autoComplete="off" className="bordered rounded" id="stateid" name="stateid" placeholder="State Name" />
						    	{ errors.stateid &&
							    	<i className="text">
							    		<i className="fa fa-warning"></i> 
							    		<span className="text-tone-primary">{errors.stateid}</span>
							    	</i>
							    }
						    </div>
						    <div className="helper">
						    	<label htmlFor="lgaid">LG Name</label>
						    	<input value={ this.state.lgaid } onChange={ this.handleFieldChange } type="text" autoComplete="off" className="bordered rounded" id="lgaid" name="lgaid" placeholder="LG Name" />
						    	{ errors.lgaid &&
							    	<i className="text">
							    		<i className="fa fa-warning"></i> 
							    		<span className="text-tone-primary">{errors.lgaid}</span>
							    	</i>
							    }
						    </div>
						</div>
						<div className="helper">
							<label htmlFor="name">Town Name</label>
						    <input value={ this.state.name } onChange={ this.handleFieldChange } type="text" autoComplete="off" className="bordered rounded" id="name" name="name" placeholder="Town Name" />
						    { errors.name &&
								<i className="text">
							    	<i className="fa fa-warning"></i> 
							    	<span className="text-tone-primary">{errors.name}</span>
							    </i>
							}
						</div>
					   	<div className="row grouped middle">
						    <div className="helper">
						    	<label htmlFor="status">Status</label>
							   	<div className="row">
							   	 	<label className="radio">
										<div className="inputs">
											<input type="radio" name="admin_status" checked={ !this.state.status }  onChange={ (e)=>this.setState({status: false}) }/>
											<span className="dot"></span>
										</div>
										<span className="label">Disabled</span>
									</label>
									<label className="radio">
										<div className="inputs">
											<input type="radio" name="admin_status" checked={ this.state.status } onChange={ (e)=>this.setState({status: true}) }/>
											<span className="dot"></span>
										</div>
										<span className="label">Enabled</span>
									</label>
							   </div>
							 </div>
						</div>
						<button className={ `rounded margin top-two ${ this.state.isSubmitting  ? 'bordered disabled' : 'fill-primary' }` } disabled={ this.state.isSubmitting }><i className="fa-plus*circle"></i> Save New Town</button>
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default CPAddTown;